export default __webpack_public_path__ + "static/media/quality.14a5743d.jpg";